import { Component, ChangeDetectionStrategy, Input, Type } from '@angular/core';
import { ListItem, ListItemComponent } from '@ui/shared/util-list';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-list-items',
    templateUrl: './list-items.component.html',
    styleUrls: ['./list-items.component.scss'],
    standalone: false,
})
export class ListItemsComponent<ListItemType extends ListItem> {
    @Input({ required: true })
    public listItems!: Array<ListItemType>;

    @Input()
    public itemContentComponentType!: Type<ListItemComponent<ListItemType>>;
}
